import { render, staticRenderFns } from "./AccountingServices.vue?vue&type=template&id=6d9d1772&scoped=true&"
import script from "./AccountingServices.vue?vue&type=script&lang=js&"
export * from "./AccountingServices.vue?vue&type=script&lang=js&"
import style0 from "./AccountingServices.vue?vue&type=style&index=0&id=6d9d1772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9d1772",
  null
  
)

export default component.exports